// Argus — Zustand store pentru state sidebar (search + filter + selected agent + bulk select).
// Memory-only (NU persist DB) cu localStorage backup pentru selectedAgentId cross-session.

import { create } from 'zustand';

export interface SidebarState {
  search: string;
  selectedAgentId: string | null;
  bulkSelectedIds: ReadonlySet<string>;
  setSearch: (search: string) => void;
  setSelectedAgentId: (agentId: string | null) => void;
  toggleBulkSelect: (agentId: string) => void;
  clearBulkSelection: () => void;
  setBulkSelection: (ids: readonly string[]) => void;
}

const SELECTED_AGENT_KEY = 'argus.ui.selectedAgentId';

export const useSidebarStore = create<SidebarState>((set) => ({
  search: '',
  selectedAgentId: typeof window !== 'undefined' ? localStorage.getItem(SELECTED_AGENT_KEY) : null,
  bulkSelectedIds: new Set<string>(),
  setSearch: (search) => set({ search }),
  setSelectedAgentId: (agentId) => {
    if (typeof window !== 'undefined') {
      if (agentId) localStorage.setItem(SELECTED_AGENT_KEY, agentId);
      else localStorage.removeItem(SELECTED_AGENT_KEY);
    }
    set({ selectedAgentId: agentId });
  },
  toggleBulkSelect: (agentId) =>
    set((state) => {
      const next = new Set(state.bulkSelectedIds);
      if (next.has(agentId)) next.delete(agentId);
      else next.add(agentId);
      return { bulkSelectedIds: next };
    }),
  clearBulkSelection: () => set({ bulkSelectedIds: new Set<string>() }),
  setBulkSelection: (ids) => set({ bulkSelectedIds: new Set(ids) }),
}));
